import Task from "../task";

const debug = false
// const debug = "calculateEstimatedCost"

export function calculateEstimatedServiceCost(task: Task):number {

    if (!task.estimate) return 0

    if (!gd._hourlyCost) {
        // console.error("#dkdn0001 - no hourly cost loaded")
        return 0
    }

    let estimateDate : Moment = task.endDate || task.scheduleDate || task.momentCreated || moment()

    let result : number = 0

    if (task.assignedToUserId) {
        result = gd._hourlyCost?.getUserServiceRate(task.assignedToUserId, estimateDate) * task.estimateHours
    } else {
        result = gd._hourlyCost.getCompanyServiceRate(estimateDate) * task.estimateHours
    }

    return result
    // return gd.utils.roundToDecimals(result)
}


export function calculateEstimatedLaborCost(task: Task):number {

    if (!task.estimate) return 0

    if (!gd._hourlyCost) {
        // console.error("#dkdn0002 - no hourly cost loaded")
        return 0
    }

    let estimateDate : Moment = task.endDate || task.scheduleDate || task.momentCreated || moment()

    let result : number = 0

    if (task.assignedToUserId) {
        result = gd._hourlyCost?.getUserLaborRate(task.assignedToUserId, estimateDate) * task.estimateHours
    } else {
        result = gd._hourlyCost.getCompanyLaborRate(estimateDate) * task.estimateHours
    }

    return result
    // return gd.utils.roundToDecimals(result)
}